import React, { FC, PropsWithChildren } from 'react';

import { FormattedMessage } from 'react-intl';

import { useShareLinkPopper } from '~/core/hooks/useShareLinkPopper';

import { ActionPopper, LinkContainer } from './styles';

type Props = {
    link: string;
    title: string;
    popperText?: string;
};

export const ShareLinkPopper: FC<PropsWithChildren<Props>> = ({ link, title, popperText, children }) => {
    const { handleClick, id, isOpen, anchorElement } = useShareLinkPopper(link);

    return (
        <>
            <LinkContainer title={title} onClick={handleClick} aria-describedby={id}>
                {children}
            </LinkContainer>
            <ActionPopper id={id} open={isOpen} anchorEl={anchorElement}>
                {popperText || (
                    <FormattedMessage
                        description="A message indicating that a user has copied a link to their clipboard"
                        defaultMessage="Link Copied"
                    />
                )}
            </ActionPopper>
        </>
    );
};

export default ShareLinkPopper;
